import { cva, type VariantProps } from 'class-variance-authority';

/**
 * HEN ArticleCard variants using HEN Design System tokens.
 * All styling references design tokens defined in tailwind.config.ts.
 */

/**
 * Container styles for the card wrapper
 */
export const articleCardContainerVariants = cva('', {
  variants: {
    layout: {
      vertical: 'flex flex-col',
      horizontal: 'flex flex-row items-start',
    },
    gap: {
      md: 'gap-md',
      sm: 'gap-sm',
      xxs: 'gap-xxs',
    },
  },
  defaultVariants: {
    layout: 'vertical',
    gap: 'md',
  },
});

/**
 * Image styles based on size variant
 */
export const articleCardImageVariants = cva('object-cover', {
  variants: {
    size: {
      lg: 'w-full aspect-[636/380]',
      md: 'w-full aspect-[636/380]',
      sm: 'w-full aspect-[636/380]',
      compact: 'w-20 h-20 flex-shrink-0',
    },
    border: {
      none: 'rounded-lg',
      padding: 'rounded-md',
      stroke: 'rounded-md',
      shadow: 'rounded-md',
    },
  },
  compoundVariants: [
    // Compact size with border uses smaller radius
    {
      size: 'compact',
      border: ['padding', 'stroke', 'shadow'],
      class: 'rounded-sm',
    },
  ],
  defaultVariants: {
    size: 'lg',
    border: 'none',
  },
});

export type ArticleCardContainerVariantProps = VariantProps<
  typeof articleCardContainerVariants
>;
export type ArticleCardImageVariantProps = VariantProps<
  typeof articleCardImageVariants
>;
